

export const PROVIDER_REQUEST_STATUS = {
    Pending: 1,
    Accepted: 2,
    Rejected: 3 ,
}

export const PATIENT_REQUEST_STATUS = {
    Pending: 1,
    InformationRequested: 2,
    InformationResponded: 3,
    Accepted: 4,
    AwaitingInitialPayment: 5,
    InitialPaymentReceived: 6,
    InProgress: 7,
    Completed: 8,
    Discharged: 9,
    Declined: 10,
    AnotherProviderAccepted: 11,
}

export const PATIENT_REQUEST_STATUS_MAP =[
    {label: "Pending", value: PATIENT_REQUEST_STATUS.Pending},
    {label: "InformationRequested", value: PATIENT_REQUEST_STATUS.InformationRequested},
    {label: "InformationResponded", value: PATIENT_REQUEST_STATUS.InformationResponded},
    {label: "Accepted", value: PATIENT_REQUEST_STATUS.Accepted},
    {label: "AwaitingInitialPayment", value: PATIENT_REQUEST_STATUS.AwaitingInitialPayment},
    {label: "InitialPaymentReceived", value: PATIENT_REQUEST_STATUS.InitialPaymentReceived},
    {label: "InProgress", value: PATIENT_REQUEST_STATUS.InProgress},
    {label: "Completed", value: PATIENT_REQUEST_STATUS.Completed},
    {label: "Discharged", value: PATIENT_REQUEST_STATUS.Discharged},
    {label: "Declined", value: PATIENT_REQUEST_STATUS.Declined},
]


export  const PROVIDER_REQUEST_SCREENS  = [
{label :"in-review", value :PROVIDER_REQUEST_STATUS.Pending},
{label :"accepted", value :PROVIDER_REQUEST_STATUS.Accepted},
{label :"rejected", value :PROVIDER_REQUEST_STATUS.Rejected},

]

export const PROVIDER_REQUEST_STATUS_MAP = {
    [PROVIDER_REQUEST_STATUS.Pending]: {
        class: "pending-status",
        label: "in-review"
    },
    [PROVIDER_REQUEST_STATUS.Accepted]: {
        class: "accepted-status",
        label: "accepted"
    },
    [PROVIDER_REQUEST_STATUS.Rejected]: {
        class: "rejected-status",
        label: "rejected"
    }
}




export const STATUS_MAP: Record<string, number> = {
    RequestSubmitted: 1,
    QuotationAvailable: 2,
    AwaitingInitialPayment: 3,
    PreparingForTreatment: 4,
    TreatmentInProgress: 5,
    PaymentCompleted: 6,
    TreatmentCompleted: 7,
    RequestClosed: 8,
};


export const StatusColorMap: Record<number, string> = {
    [STATUS_MAP.RequestSubmitted]: "status-color-submitted",
    [STATUS_MAP.QuotationAvailable]: "status-color-quotation-available",
    [STATUS_MAP.AwaitingInitialPayment]: "status-color-awaiting-initial-payment",
    [STATUS_MAP.PreparingForTreatment]: "status-color-preparing-for-treatment",
    [STATUS_MAP.TreatmentInProgress]: "status-color-treatment-in-progress",
    [STATUS_MAP.PaymentCompleted]: "status-color-payment-completed",
    [STATUS_MAP.TreatmentCompleted]: "status-color-treatment-completed",
    [STATUS_MAP.RequestClosed]: "status-color-request-closed",
};


export const STATUS_MAP_TEXT: Record<string, string> = {
    [STATUS_MAP.RequestSubmitted]: "Submited",
    [STATUS_MAP.QuotationAvailable]: "Quotation Available",
    [STATUS_MAP.AwaitingInitialPayment]: "Waiting Payment",
    [STATUS_MAP.PreparingForTreatment]: "Preparing for Treatment",
    [STATUS_MAP.TreatmentInProgress]: "Treatment in Progress",
    [STATUS_MAP.PaymentCompleted]: "Payment Completed",
    [STATUS_MAP.TreatmentCompleted]: "Treatment Completed",
    [STATUS_MAP.RequestClosed]: "Request Closed",
};
export const STATUS_MAP_KEY: Record<number, number> = {
    [STATUS_MAP.RequestSubmitted]: 1,
    [STATUS_MAP.QuotationAvailable]: 2,
    [STATUS_MAP.AwaitingInitialPayment]: 3,
    [STATUS_MAP.PreparingForTreatment]: 4,
    [STATUS_MAP.TreatmentInProgress]: 5,
    [STATUS_MAP.PaymentCompleted]: 6,
    [STATUS_MAP.TreatmentCompleted]: 7,
    [STATUS_MAP.RequestClosed]: 8,
};


export const FLOW_STEPS = [
    { key: STATUS_MAP.RequestSubmitted, label: STATUS_MAP_TEXT[STATUS_MAP.RequestSubmitted] },
    { key: STATUS_MAP.QuotationAvailable, label: STATUS_MAP_TEXT[STATUS_MAP.QuotationAvailable] },
    { key: STATUS_MAP.AwaitingInitialPayment, label: STATUS_MAP_TEXT[STATUS_MAP.AwaitingInitialPayment] },
    { key: STATUS_MAP.PreparingForTreatment, label: STATUS_MAP_TEXT[STATUS_MAP.PreparingForTreatment] },
    { key: STATUS_MAP.TreatmentInProgress, label: STATUS_MAP_TEXT[STATUS_MAP.TreatmentInProgress] },
    { key: STATUS_MAP.PaymentCompleted, label: STATUS_MAP_TEXT[STATUS_MAP.PaymentCompleted] },
    { key: STATUS_MAP.TreatmentCompleted, label: STATUS_MAP_TEXT[STATUS_MAP.TreatmentCompleted] },
    { key: STATUS_MAP.RequestClosed, label: STATUS_MAP_TEXT[STATUS_MAP.RequestClosed] },
];



export const MISSING_DATA_STATUS= {
    NoRequestForMissingData : 1,
    AskingForMissingData: 2,
    MissingDataRecieved: 3,
}


export const MissingDataStatusMap = {
    [MISSING_DATA_STATUS.NoRequestForMissingData]: "no-request-for-missing-data",
    [MISSING_DATA_STATUS.AskingForMissingData]: "asking-for-missing-data",
    [MISSING_DATA_STATUS.MissingDataRecieved]: "missing-data-recieved",
}

